import React, {ReactNode} from 'react';
import classNames from 'classnames';
import type {DOMAttributes} from '@react-types/shared';

import {TypographySize, useTypography} from '../../../../hooks/typography';
import {AlertOutlineIcon} from '../../../../icons';

import styles from './styles.module.css';

type Props = {
    children: ReactNode;
} & DOMAttributes;

export const ErrorMessage: React.FunctionComponent<Props> = ({children, ...props}) => {
    const typographyCls = useTypography({
        size: TypographySize.BodyS,
        noDefaultColor: true,
    });

    return (
        <div {...props} className={classNames(typographyCls, styles.errorMessage)}>
            <AlertOutlineIcon className={styles.icon} />
            <p className={styles.text}>{children}</p>
        </div>
    );
};
